<div class="modal-header">
  <h4 class="modal-title"> {{'mountingAssistant.title.base_settings' | translate}}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh" maxHeightOffset>
    <div class="form-check checkbox">
      <input class="form-check-input ng-untouched ng-pristine ng-valid" type="checkbox" id="transparencyMode">
      <label class="form-check-label" for="transparencyMode">
        {{ 'mountingAssistant.baseSettings.label.transparency' | translate }}
      </label>
    </div>
    <div class="form-check checkbox">
      <input class="form-check-input ng-untouched ng-pristine ng-valid" type="checkbox" id="enableAutozoom">
      <label class="form-check-label" for="enableAutozoom">
        {{ 'mountingAssistant.baseSettings.label.autozoom' | translate }}
      </label>
    </div>
    <div class="form-check checkbox">
      <input class="form-check-input ng-untouched ng-pristine ng-valid" type="checkbox" id="enableArticleDetails">
      <label class="form-check-label" for="enableArticleDetails">
        {{ 'mountingAssistant.baseSettings.label.articledetails' | translate }}
      </label>
    </div>
    <div class="form-check checkbox">
      <input class="form-check-input ng-untouched ng-pristine ng-valid" type="checkbox" id="enableDrillingHoleView">
      <label class="form-check-label" for="enableDrillingHoleView">
        {{ 'mountingAssistant.baseSettings.label.drilling_hole_view' | translate }}
      </label>
    </div>
    <div class="form-check checkbox">
      <input class="form-check-input ng-untouched ng-pristine ng-valid" type="checkbox" id="optimizeButtonSizeForTouch">
      <label class="form-check-label" for="optimizeButtonSizeForTouch">
        {{ 'mountingAssistant.baseSettings.label.button_size' | translate }}
      </label>
    </div>
    <div class="mt-3 mb-2">
      <a class="link"
         (click)="openEditArticleNumberMappingDialog()">
        {{'editArticleNumberMappingPopup.title' | translate}}
      </a>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary btn-forward" (click)="close()">{{ 'global.label.close' | translate }}</button>
</div>
